import { environment } from "src/environments/environment";

import { MsalAngularConfiguration } from "@azure/msal-angular";
import { Configuration, Logger, LogLevel } from "msal";

export function msalConfig(): Configuration {
  return {
    auth: {
      authority: environment.auth.url,
      validateAuthority: false,
      clientId: environment.auth.clientId,
      redirectUri: `${window.location.origin}/auth/authenticated`,
      postLogoutRedirectUri: "https://innovian.net/",
      navigateToLoginRequestUrl: true,
    },
    system: {
      logger: new Logger(
        /* istanbul ignore next */
        (level, message, pii) => {
          console.log(message);
        },
        {
          level: environment.production ? /* istanbul ignore next */ LogLevel.Error : LogLevel.Warning, // LogLevel.Verbose,
          piiLoggingEnabled: !environment.production,
        }
      )
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false
    },
  };
}

export function msalAngularConfig(): MsalAngularConfiguration {
  return {
    popUp: false,
    consentScopes: [
      "openid",
      "profile",
    ],
    unprotectedResources: [ ],
    protectedResourceMap: new Map([
      [environment.api.globalHost, [environment.auth.clientId]],
      [environment.api.clientHost, [environment.auth.clientId]],
    ]),
    extraQueryParameters: { }
  };
}
